import { render, staticRenderFns } from "./OnboardingCardVerification.vue?vue&type=template&id=f8fb06b0&"
import script from "./OnboardingCardVerification.vue?vue&type=script&lang=js&"
export * from "./OnboardingCardVerification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports